import axios from 'axios';
import {backendHost} from '../../config';

export const getPostbackLogs = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/postback`, {params});
};